module.exports = __webpack_public_path__ + "img/fundo.eb123253.jpg";